import { SVGProps, Ref, forwardRef } from 'react';

export const ClocheFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M9.167.5a.867.867 0 0 1 0 1.733H8.7V4.78c1.934.078 3.56.499 4.645 1.544 1.248 1.204 1.595 3.045 1.214 5.474-.219 1.389.136 1.898.336 2.083a.87.87 0 0 0 .45.218H16V15.5H0v-1.4h.646l.01-.001a.867.867 0 0 0 .451-.218c.2-.185.553-.694.335-2.083-.381-2.43-.034-4.27 1.214-5.474 1.085-1.046 2.71-1.466 4.645-1.544V2.233h-.467a.867.867 0 0 1-.862-.778l-.005-.088.005-.089A.867.867 0 0 1 6.834.5z"
                fill="currentColor"
            />
        </g>
    </svg>
));
ClocheFilledSize16Glyph.displayName = 'ClocheFilledSize16Glyph';
